import { createContext, useContext } from "react";
import type { MetascalpState } from "./metascalp-link";
import type { TerminalCommand } from "./terminal-action";
import type { TerminalSettings } from "./terminal-settings";
import type { LinkState } from "./tiger-link";

/** Повод открыть лист настроек: `groups` — не выбраны группы окон, лист ставит фокус в поле набора. */
export type TerminalSettingsHint = "groups";

/** Состояние связи с пометкой терминала: у каждого свой набор состояний. */
export type TerminalLinkState =
  | { terminal: "tigertrade"; state: LinkState }
  | { terminal: "metascalp"; state: MetascalpState["kind"] | "off" };

/**
 * Что действие «открыть в терминале» берёт у экрана (§10 1.36). Контекст, а
 * не проп: строка плотности стоит в трёх таблицах (плотности, монеты,
 * ситуации), и пробрасывать одно и то же через каждую значило бы трогать их
 * все. Провайдер ставит экран плотностей; везде, где его нет (библиотека,
 * карточки, закрепления), действия нет — это и требует спека.
 */
export interface TerminalControls {
  settings: TerminalSettings;
  /** Состояние связи выбранного терминала: соединение TigerTrade или порт MetaScalp. */
  linkState: TerminalLinkState;
  /** Состояние связи словами — вторая строка подсказки кнопки. */
  statusText: string;
  /** Отправить команду в следующую группу или связку круга и показать исход (§10 1.45, §89). */
  onSend: (command: TerminalCommand, densityId: string) => void;
  /** Открыть лист настроек терминала — он один на экран. */
  onOpenSettings: (hint?: TerminalSettingsHint) => void;
}

export const TerminalControlsContext = createContext<TerminalControls | null>(null);

/** `null` — провайдера нет, действия нет. */
export function useTerminalControls(): TerminalControls | null {
  return useContext(TerminalControlsContext);
}
